module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAS1JREFUWAntlsENgkAQRcEqLMGDsQeK4GQB1EQBnrQHapBoYgl2gf/LbmJwwZldIhxmkgGD83cef1g0yyzMAXPAHDAHzAFzYEkHcm3zuq5P0ByQZVVVD4kemh3qzsgWmqNE42s2/oPiTLg9snGNJ6WupnEaalURA1iiwxO5RU5CfsCxlhpqVaEeMVcPNC6G45bUSEijAH9BzgXHPtGAY5C8juAz58f65e67QnhIAmSPgFu8PAscF0oG5CIDSF7ihkhyjoswYnZxr/zTMdnBgXt0jrGOEQfgip5vBZskBOffhVPfuRsQn6JGLAGQ1Ego1YCaxpraMVj1Ls7z/ILFRJvAjZzPpf/t5j8aVagBu667osMNKXrPeUjc2B2aVkVnxeaAOWAOmAPmgDmwuAMvsd2LGlsoZxwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/close@2x.png
// module id = LhFq
// module chunks = 0